module.exports = __webpack_public_path__ + "img/1banner.b98fdd2b.png";